/*
 |--------------------------------------------------------------------------
 | Document Ready Function
 |--------------------------------------------------------------------------
 */

$(function () {
    'use strict';

    /**
     * Display mobile menu.
     */
    $('.menu-toggle, .menu-toggle-logged').click((e) => {
        e.preventDefault();

        $(e.currentTarget).toggleClass('active');
        $('.menu-mobile, .navbar').toggleClass('active');
        $('body').toggleClass('overflow-hidden');

        if ($(e.currentTarget).hasClass('menu-toggle-logged-open')) {
            $('.menu-toggle-logged-close').toggleClass('active');
        } else if ($(e.currentTarget).hasClass('menu-toggle-logged-close')) {
            $('.menu-toggle-logged-open').toggleClass('active');
        }
    });

    /**
     * Display mobile menu categories.
     */
    $('.menu-link-categories').click((e) => {
        e.preventDefault();

        $.each($('.menu-item-categories'), function (key, value) {
            $(this).animate({ height: 0 });
        });

        if ($(e.currentTarget).hasClass('active')) {
            $(e.currentTarget).removeClass('active');
        } else {
            $.each($('.menu-link-categories'), function (key, value) {
                $(this).removeClass('active');
            });

            $(e.currentTarget).addClass('active');
            $(e.currentTarget).next().animate({ height: '100%' });
        }
    });

    /**
     * Articles - display mobile menu.
     */
    $('.menu-categories').click((e) => {
        e.preventDefault();

        $(e.currentTarget).toggleClass('show');
        $('.categories-list').toggleClass('hidden');
    });

    /**
     * Hide benefit.
     */
    $('.close-menu-benefit').click((e) => {
        e.preventDefault();

        $(e.currentTarget).closest('.menu-benefit').addClass('hidden');
        $('.menu-mobile-links').addClass('benefit-close');
    });

    /**
     * Toggle serach bar in the desktop screens.
     */
    $('.search-toggle').click((e) => {
        e.preventDefault();

        $(e.currentTarget).toggleClass('active');
        $('.search-container').toggleClass('!flex').attr('autofocus', true);
    });

    $(document).keyup(function(e) {
        if (e.key === "Escape") {
            $('.search-toggle').removeClass('active');
            $('.search-container').removeClass('!flex');
        }
    });
});
